import {useContext} from 'react';
import PerformanceMonitorTrackSelfContext from 'src/internal/provider/PerformanceMonitorTrackSelfContext';

export default function usePerformanceMonitorTrack(): (
  name: string,
) => () => void {
  return useContext(PerformanceMonitorTrackSelfContext);
}
